import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import '../styles/2025.css';
import confetti from 'canvas-confetti';
import sound from '../assets/dark-future-logo.mp3';
import ics from '../assets/Idna‘s Geburtstagsfeier.ics'

function ParallaxCard(props) {
    const soundEffect = new Audio();
    soundEffect.autoplay = true;

    const [isOpen, setIsOpen] = useState(false);
    const { name = '' } = useParams();
    const [showButtons, setShowButtons] = useState(false);


    const handleCardClick = () => {
        setIsOpen(!isOpen);
        if (!isOpen) {
            soundEffect.src = sound;
            soundEffect.play();
            setTimeout(() => {
                triggerConfetti();
                resetAnimation();
            }, 2000);
            setTimeout(() => {

                setShowButtons(true);
            }, 6000);

        } else {
            setShowButtons(false);
        }
    };

    const triggerConfetti = () => {
        confetti({
            particleCount: 200,
            spread: 90,
            origin: { x: 0.5, y: 0.5 },
            colors: ['#ff0', '#f00', '#0f0', '#00f'],
        });
    };

    const resetAnimation = () => {
        const textElements = document.querySelectorAll('.card-content h2, .card-content p');
        textElements.forEach(element => {
            element.classList.remove('active');
            void element.offsetWidth; // Trigger reflow
            element.classList.add('active');
        });
    };

    const handleWhatsAppClick = (message) => {
        const url = `https://wa.me/+491701110607?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

    const handleICalClick = () => {
        window.open(ics, '_blank');
    };

    return (

        <div className="parallax-container">
            <div className="balls-background">
                <div className="ball"></div>
                <div className="ball"></div>
                <div className="ball"></div>
            </div>
            <div
                className={`parallax-card ${isOpen ? 'open' : ''}`}
                onClick={handleCardClick}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && handleCardClick()}
            >
                <div className="card-cover">

                    <h2>Hallo {name}</h2>

                    <h2>🎉 Du bist eingeladen! 🎉</h2>
                    <p>{props.description}</p>
                </div>
                <div className={`card-content ${isOpen ? 'active' : ''}`}>
                    <h2 dangerouslySetInnerHTML={{ __html: props.heading }}></h2>
                    <p>
                        Wann: <strong>{props.date}</strong> <br/>
                        Wo: <strong>{props.location}</strong> <br/>
                        Motto: <strong>{props.theme}</strong>
                    </p>
                    <p dangerouslySetInnerHTML={{ __html: props.message}} ></p>

                    {showButtons && (
                        <div>
                            <p className={'disclaimer'}>{props.disclaimer}</p>
                            <div className="button-container">
                                <button className="neon-button"
                                        onClick={() => handleWhatsAppClick('Hi, ich bin dabei!')}>
                                    Zusagen auf WhatsApp
                                </button>
                                <button className="neon-button dark"
                                        onClick={() => handleWhatsAppClick('Hi, ich kann leider nicht kommen!')}>
                                    Absagen auf WhatsApp
                                </button>
                            </div>
                            <button className="calender-button" onClick={handleICalClick}>
                                <span className="icon">📆</span> zu Kalender hinzufügen
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ParallaxCard;